import SvgIcon from "./IconShare.svg?react";
const IconShare = SvgIcon;
export default IconShare;
